export const APP_TOKEN = 'token';
export const USER_TYPE = 'user_type';
export const USER_TYPE_CUSTOMER = 'customer';
export const USER_TYPE_MOSQUE = 'mosque';
export const USER_TYPE_ADMIN = 'admin';
export const USER_ID = 'userId';
